module.exports = __webpack_public_path__ + "static/img/photo08.689355c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tokyo/photo08.jpg
// module id = 6mDT
// module chunks = 0